/* eslint @typescript-eslint/no-redundant-type-constituents: 0 */
import { IntlMessageFormat } from 'intl-messageformat';

const _user_job_status_enum_fr = new IntlMessageFormat(
    [
        {
            type: 5,
            value: 'enum',
            options: {
                student: { value: [{ type: 0, value: 'Étudiant' }] },
                employee: { value: [{ type: 0, value: 'Employé' }] },
                executive: { value: [{ type: 0, value: 'Cadre' }] },
                leader: { value: [{ type: 0, value: 'Dirigeant' }] },
                entrepreneur: { value: [{ type: 0, value: 'Entrepreneur' }] },
                freelance: { value: [{ type: 0, value: 'Freelance' }] },
                __not_other: { value: [] },
                other: { value: [] },
            },
        },
    ],
    'fr',
);

const _user_job_status_enum_en = new IntlMessageFormat(
    [
        {
            type: 5,
            value: 'enum',
            options: {
                student: { value: [{ type: 0, value: 'Student' }] },
                employee: { value: [{ type: 0, value: 'Employee' }] },
                executive: { value: [{ type: 0, value: 'Executive' }] },
                leader: { value: [{ type: 0, value: 'Leader' }] },
                entrepreneur: { value: [{ type: 0, value: 'Entrepreneur' }] },
                freelance: { value: [{ type: 0, value: 'Freelance' }] },
                __not_other: { value: [] },
                other: { value: [] },
            },
        },
    ],
    'en',
);

export function user_job_status_enum(
    args: {
        enum:
            | 'employee'
            | 'entrepreneur'
            | 'executive'
            | 'freelance'
            | 'leader'
            | 'student';
    },
    lang: string,
): string {
    if (lang.startsWith('fr')) {
        return _user_job_status_enum_fr.format(args) as unknown as string;
    }

    if (lang.startsWith('en')) {
        return _user_job_status_enum_en.format(args) as unknown as string;
    }

    return _user_job_status_enum_fr.format(args) as unknown as string;
}
